<template>
  <aside class="ModalDialog" :_hidden="hidden">
    <div class="dialogPanel">
      <slot />
      <CloseButton @click="() => hideProductModal()" class="closeButton" />
    </div>
  </aside>
</template>

<script>
import CloseButton from '~/vue-components/shared/CloseButton.vue'

export default {
  components: {
    CloseButton,
  },
  inject: ['hideProductModal'],
  data() {
    return {
      hidden: true,
    }
  },
}
</script>

<style scoped>
.ModalDialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 50;
}

.ModalDialog[hidden] {
  display: none;
}

.dialogPanel {
  background-color: var(--bg-color-white);
  padding: var(--spacing-17) var(--spacing-10) var(--spacing-10);
  margin: 0;
  width: 100%;
  max-width: unset;
  height: 100%;
  max-height: unset;
  position: relative;
}

.closeButton {
  position: absolute;
  top: var(--spacing-8);
  right: var(--spacing-8);
}

@media (--screen-lg) {

  .dialogPanel {
    margin: auto;
    width: 1024px;
    max-width: calc(100vw - 3rem);
    height: fit-content;
    min-height: 600px;
    max-height: calc(100vh - 3rem);
    overflow-y: auto;
    padding-top: var(--spacing-6);
    border-radius: 10px;
  }
}
</style>
